module.exports = __webpack_public_path__ + "img/icon-livecasino-black.a98e35f8.svg";